import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Chapter, Eyebrow, cardSx, colors } from './design';
import { PublicLocale } from './routes';

export function TechnologyPartnership({ locale = 'sv' }: { locale?: PublicLocale }) {
  const en = locale === 'en';
  const [imageFailed, setImageFailed] = useState(false);
  return <Chapter compact>
    <Box component="aside" aria-labelledby="technology-partnership-title" sx={{
      ...cardSx, display: 'grid', gridTemplateColumns: { xs: '1fr', md: '240px minmax(0, 1fr)' },
      gap: { xs: 3, md: 5 }, alignItems: 'center',
    }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1.5 }}>
        {imageFailed
          ? <Typography role="status" sx={{ color: colors.muted, fontSize: 14 }}>
            {en ? 'The partner logo could not be loaded.' : 'Partnerns logotyp kunde inte laddas.'}
          </Typography>
          : <Box component="img" src="/images/landing/syntheticaidata-logo.png"
            alt={en ? 'syntheticAIdata logo' : 'syntheticAIdatas logotyp'} width={64} height={64}
            loading="lazy" decoding="async" onError={() => setImageFailed(true)} sx={{ display: 'block' }} />}
        <Typography translate="no" sx={{ fontSize: 22, fontWeight: 600 }}>syntheticAIdata</Typography>
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Eyebrow>{en ? 'DEVELOPMENT PARTNERSHIP' : 'UTVECKLINGSSAMARBETE'}</Eyebrow>
        <Typography id="technology-partnership-title" variant="h2" sx={{ fontSize: { xs: 26, md: 32 } }}>
          {en ? 'How we develop the image analysis.' : 'Så utvecklar vi bildanalysen.'}
        </Typography>
        <Typography sx={{ color: colors.muted, mt: 2 }}>
          {en
            ? 'Our collaboration with syntheticAIdata uses synthetic training images with variations in facade materials, lighting and camera angles. This helps us develop the technology for the varied conditions we encounter during an inspection.'
            : 'I samarbetet med syntheticAIdata används syntetiska träningsbilder med variationer i bland annat fasadmaterial, ljus och kameravinklar. På så sätt kan vi utveckla tekniken för de varierande förhållanden som möter oss vid en inspektion.'}
        </Typography>
        <Box component="a" href="https://syntheticaidata.com/use-cases/klaraview/" target="_blank" rel="noopener noreferrer"
          aria-label={en
            ? 'Read about the collaboration with syntheticAIdata (opens in a new tab)'
            : 'Läs om samarbetet med syntheticAIdata (öppnas i ny flik)'}
          sx={{
            display: 'inline-flex', alignItems: 'center', gap: 1, minHeight: 44, mt: 2,
            color: colors.rust, textUnderlineOffset: '4px',
            '&:hover': { color: colors.rustDark },
            '&:focus-visible': { outline: `3px solid ${colors.rust}`, outlineOffset: 4 },
          }}>
          {en ? 'Read about the collaboration with syntheticAIdata' : 'Läs om samarbetet med syntheticAIdata'}
          <Box component="span" aria-hidden="true">↗</Box>
        </Box>
      </Box>
    </Box>
  </Chapter>;
}
